import { Component, OnInit } from '@angular/core';
import { AuthService } from '@aiwyn/auth';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false,
})
export class LogoutComponent implements OnInit {

  /**
   * The Kotlin app will redirect to this endpoint if there is a problem on the server
   * to ensure that the client side objects are cleaned up.
   *
   * @param authService The Authentication Service.
   */
  constructor(private authService: AuthService) {
  }

  ngOnInit(): void {
    this.authService.signOut().pipe(
      take(1),
    ).subscribe();
  }

}
